/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

import './BarSegment.scss';

import DisclosureModal from 'components/shared/Disclosure/DisclosureModal';
import Content from 'services/Content';
import { string } from 'prop-types';
import React from 'react';
import classnames from 'classnames';

const BarSegment = ({
  label: text,
  segmentClass = '',
  children,
  tooltipContent,
  isAlaska529Only
}) => {
  const segmentContentClassname = classnames('segment-content', {
    isAlaska529Only
  });
  const isYearToDate =
    text &&
    typeof text.trim == 'function' &&
    text.trim() === 'Year-To-Date Change';
  return (
    <section className={`bar-segment ${segmentClass}`}>
      <div className="segment-label">
        {text}
        {tooltipContent && (
          <DisclosureModal
            className={`bar-segment-tooltip ${segmentClass}`}
            content={tooltipContent}
            title={text}
            label={`tooltip-label ${segmentClass}`}
            hideLinkContent
          />
        )}
        {isYearToDate && (
          <DisclosureModal
            className="total-balance-disclosure"
            content={Content.yearToDateDisclosure}
            title="Important Information about your Year-To-Date Calculation"
            label="ytd-disclosure"
            hideLinkContent
          />
        )}
      </div>
      <div className={segmentContentClassname + ' ' + segmentClass}>
        {children}
      </div>
    </section>
  );
};

BarSegment.propTypes = {
  segmentClass: string
};

export default BarSegment;
